module.exports = __webpack_public_path__ + "fonts/iconfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/iconfont.woff2?t=1620798987493
// module id = 991
// module chunks = 0